const routes = (() => {
    return {
        HOMEPAGE: 'hotel/',
        SEARCH: 'hotel/search',
        CHECKOUT: 'hotel/checkout',
        PRODUCT: 'hotel/hotel-details',
        CONFIRMATION: 'hotel/confirmation',
        INVOICE: 'hotel/invoice',
        CORRECTION_AMENDMENT: 'hotel/correction-amendment',
        MY_PROFILE: 'hotel/my-profile',
        MY_BOOKING: 'hotel/my-bookings',
        AMENDMENT: 'hotel/modify-booking',
        HCN_UPDATE: 'hotel/hcn-update'
    };
})();
export default routes;
